import styled from 'styled-components'

import {margin} from '../styledHelpers'
import { ButtonLink } from "buoy-core"

const Container = styled.div`
  ${margin}
  ${props => props.center && `
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  `}
  ${props => props.width && `width: ${props.width};`}
  ${props => props.responsive && `
    @media (max-width: 640px) {
      width: 100%;
    }
  `}
  ${props => props.height && `height: ${props.height};`}
  ${props => props.flex && 'display: flex;'}
  ${props => props.wrap && `flex-wrap: wrap;`}
  ${props => props.rotation && `transform: rotate(${props.rotation});`}
  ${props => props.onClick && `cursor: pointer;`}
  ${props => props.inline && 'display: inline-flex;'}
`

const ButtonContainer = Container.withComponent(ButtonLink)

export {Container as default, ButtonContainer}


// WEBPACK FOOTER //
// ./assets/common/components/Container.js